import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, type TopNavClickBiEvent } from '@wix/da-bi/pkg/events';
import { ListItemLink } from '@wix/da-ds/pkg/List/ListItem';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge/BetaBadge';

interface Props {}

const StudioListItem: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <ListItemLink
      label={t('dreamup.sidebar.links.studio')}
      href={Url.studio({ playground: 'dreamup' })}
      biData={BiData<TopNavClickBiEvent>({
        evid: 700,
        link_name: t('common.manageInStudio'),
        link_url: Url.studio({ playground: 'dreamup' }),
      })}
      suffix={<BetaBadge badgeType="new" size="medium" variant="purple" />}
    />
  );
};

StudioListItem.displayName = 'StudioListItem';

export default StudioListItem;
